module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./~/@utex/ui-kit/~/core-js/internals/is-pure.js
// module id = 273
// module chunks = 118